import { create } from 'zustand'
import type { AgentStatus, NodeStatus, ProvenanceSentence } from '@/lib/types'

interface OutreachStreamState {
  agentStatus: AgentStatus
  nodeStatuses: Record<string, NodeStatus>
  email: { subject: string; body: string } | null
  runId: string | null
  errorMessage: string | null
  provenance: ProvenanceSentence[]
  setAgentStatus: (status: AgentStatus) => void
  setNodeStatus: (node: string, status: NodeStatus) => void
  setEmail: (email: { subject: string; body: string }) => void
  setRunId: (runId: string) => void
  setErrorMessage: (message: string) => void
  setProvenance: (provenance: ProvenanceSentence[]) => void
  reset: () => void
}

const initialState = {
  agentStatus: 'idle' as AgentStatus,
  nodeStatuses: {} as Record<string, NodeStatus>,
  email: null,
  runId: null,
  errorMessage: null,
  provenance: [] as ProvenanceSentence[],
}

export const useOutreachStore = create<OutreachStreamState>((set) => ({
  ...initialState,
  setAgentStatus: (agentStatus) => set({ agentStatus }),
  setNodeStatus: (node, status) =>
    set((s) => ({ nodeStatuses: { ...s.nodeStatuses, [node]: status } })),
  setEmail: (email) => set({ email }),
  setRunId: (runId) => set({ runId }),
  setErrorMessage: (errorMessage) => set({ errorMessage }),
  setProvenance: (provenance) => set({ provenance }),
  reset: () => set(initialState),
}))
